"use strict";
function _(t) {
  return !!(t && t.__CANCEL__);
}
export {
  _ as default
};
//# sourceMappingURL=index.es107.js.map
